import React, {Fragment, useState, FunctionComponent} from 'react';
import './CartItems.less';
import {ListSplitter} from 'elements/list-splitter/ListSplitter.tsx';
import {CartItemEditable} from '../cart-item-editable/CartItemEditable.tsx';
import {CartItemReadonly} from '../cart-item-readonly/CartItemReadonly.tsx';
import {Card, CardStyles} from 'elements/card/Card.tsx';
import {CartItem, OrderLineToken} from '../../../helpers/order-line.helper.types';
import {ModifierGroupId} from '../../../helpers/modifier.helper.types';

interface CartItemsProps {
	cartItems: Array<CartItem>,
	onQuantityDecClick: (orderLineToken: OrderLineToken) => void,
	onQuantityIncClick: (orderLineToken: OrderLineToken) => void,
	onModifierGroupClick: (modifierGroupId: ModifierGroupId, orderLineToken: OrderLineToken) => void,
	isAlignByContainer?: boolean,
	isReadOnly?: boolean
}

export const CartItems: FunctionComponent<CartItemsProps> = ({
																															 cartItems,
																															 onQuantityDecClick,
																															 onQuantityIncClick,
																															 onModifierGroupClick,
																															 isAlignByContainer = false,
																															 isReadOnly = false
																														 }) => {
	const [editableItemId, setEditableItemId] = useState(null);

	return (
		<ul className="cart-items">
			{cartItems
				.sort((cartItem1, cartItem2) => cartItem1.token - cartItem2.token)
				.map((cartItem, index) => {
					return (
						<Fragment key={cartItem.token}>
							{index > 0 && <ListSplitter isAlignByContainer={isAlignByContainer}/>}
							<li
								className="cart-items__item"
								onClick={() => (cartItem.token === editableItemId) ? setEditableItemId(null) : setEditableItemId(cartItem.token)}
							>
								{!isReadOnly && cartItem.token === editableItemId ? (
									<Card style={CardStyles.NESTED}>
										<CartItemEditable
											quantity={cartItem.quantity}
											name={cartItem.name}
											price={cartItem.price}
											modifierGroups={cartItem.modifierGroups}
											modifierSelections={cartItem.modifierSelections}
											onQuantityDecClick={(event) => {
												event.stopPropagation();
												onQuantityDecClick(cartItem.token);
											}}
											onQuantityIncClick={(event) => {
												event.stopPropagation();
												onQuantityIncClick(cartItem.token);
											}}
											onModifierGroupClick={(e, modifierGroupId) => {
												e.stopPropagation();
												onModifierGroupClick(modifierGroupId, cartItem.token);
											}}
										/>
									</Card>
								) : (
									<CartItemReadonly
										quantity={cartItem.quantity}
										name={cartItem.name}
										price={cartItem.price}
										modifierGroups={cartItem.modifierGroups}
										modifierSelections={cartItem.modifierSelections}
										vatSum={cartItem.vatSum}
										vatPercent={cartItem.vatPercent}
									/>
								)}
							</li>
						</Fragment>
					);
				})}
		</ul>
	);
};
